<template>
  <div class="c-mypage-index">
    <PageTitle
      titleText="ユーザー情報"
      asideText="メールアドレスの登録変更、パスワードの変更が可能です。
      IDは変更できません。予めご了承ください。"
    />

    <!-- textarea -->
    <div id="textarea">
      <!-- <form
          name="entry_form"
          action="infoconf.php?now_time=20210610183927"
          method="post"
        > -->
      <div class="ic-mypage-index__infoTable">
        <table
          cellpadding="0"
          cellspacing="2"
          border="0"
          summary="infochange"
          class="infochangeinput"
        >
          <tr>
            <td class="head">ID</td>
            <td class="input">
              <span class="asideText"
                >「ご契約者様専用サイトのご案内」をご覧ください。</span
              >
            </td>
          </tr>

          <tr>
            <td class="head">パスワード</td>
            <td class="input">
              <router-link
                :to="{
                  name: 'mypage-password',
                  params: { mc_code: mcCode },
                }"
              >
                <Button text="パスワードを変更する" width="20rem"></Button>
              </router-link>
            </td>
          </tr>

          <tr>
            <td class="head">メールアドレス</td>
            <td class="input">
              <span id="mailstr">{{
                hashEmailAddress(currentUser.email)
              }}</span>
              <router-link
                :to="{
                  name: 'mypage-email',
                  params: { mc_code: mcCode },
                }"
              >
                <Button text="メールアドレスを変更する" width="20rem"></Button
              ></router-link>
            </td>
          </tr>
        </table>
      </div>
      <!-- </form> -->
    </div>
    <div class="c-mypage-index__returnTopButtonWrap">
      <router-link
        class="c-globalNav__nav__item__title"
        :to="{
          name: 'top',
          params: { mc_code: mcCode },
        }"
      >
        <Button text="トップページへ" width="20rem"></Button>
      </router-link>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import PageTitle from "@/components/PageTitle.vue";
export default {
  components: { Button, PageTitle },
};
</script>

<style>
/* @import "/mc/css/mc/infochange_layout.css"; */
</style>
